import React from "react";
import PropTypes from "prop-types";
import EngravingIcon from "../../images/customisation-asset-thumbnails/Engraving_50x50.png";
import InitialsIcon from "../../images/customisation-asset-thumbnails/Initials_50x50.png";
import { createSelectionTitleString } from "../../support/helpers";

const propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  optionKey: PropTypes.string.isRequired,
  selectionTitle: PropTypes.string,
  selectionText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const defaultProps = {};

const ConfigCell = ({
  title,
  image,
  optionKey,
  selectionTitle,
  selectionText,
  onClick,
}) => {
  const getImageSrc = () => {
    if (optionKey === "engraving") {
      return EngravingIcon;
    } else if (optionKey === "initials") {
      return InitialsIcon;
    }
    return image;
  };

  return (
    <div className="flex justify-between mt-8 items-center">
      <div className="h-10 w-10">
        <img src={getImageSrc()} alt={selectionTitle} />
      </div>
      <div className="flex-grow flex flex-col px-4">
        <div className="heading-9 uppercase">{title}</div>
        <div className="body-2">
          {createSelectionTitleString(optionKey, selectionText, selectionTitle)}
        </div>
      </div>
      <button className="edit-text text-pale-blue" onClick={onClick}>
        Edit
      </button>
    </div>
  );
};

ConfigCell.propTypes = propTypes;

ConfigCell.defaultProps = defaultProps;

export default ConfigCell;
